import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface CancelGenerationParams {
  chatId: string;
}

/**
 * React Query hook for cancelling chat generation.
 *
 * @returns Mutation object with mutate/mutateAsync functions and loading/error states
 *
 * @example
 * ```tsx
 * const cancelGeneration = useCancelGeneration();
 *
 * const handleCancel = async () => {
 *   try {
 *     await cancelGeneration.mutateAsync({ chatId: "chat_123" });
 *     console.log("Cancellation requested");
 *   } catch (error) {
 *     console.error("Failed to cancel:", error);
 *   }
 * };
 * ```
 */
export function useCancelGeneration() {
  const { chatService } = useDomainServices();

  return useMutation<void, Error, CancelGenerationParams>({
    mutationFn: async ({ chatId }) => {
      return await chatService.cancelGeneration(chatId);
    },
  });
}
